/*
 * Copyright (C) Serfim TIC
 * All rights reserved
 */
import { RestServiceProvider } from '../../RestServiceProvider';
import {CategoryService} from "./CategoryService";

class CategoryServiceProvider extends RestServiceProvider {
    getServiceInstance($q, resource, $httpParamSerialiserJQLike, $log) {
        return new CategoryService($q, resource, $httpParamSerialiserJQLike, $log);
    }
}

export { CategoryServiceProvider };



// WEBPACK FOOTER //
// ./src/main/front/scripts/module/organization/service/CategoryServiceProvider.js